export class ApiError extends Error {
  status: number;
  code: string;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

const ensuredDiscussionGroups = new Set<string>();

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData) && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' });
  const contentType = response.headers.get('Content-Type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const objectPayload = typeof payload === 'object' && payload !== null ? payload as { error?: { code?: string; message?: string } } : null;
    const error = objectPayload?.error ? { code: objectPayload.error.code || 'REQUEST_FAILED', message: objectPayload.error.message || `HTTP ${response.status}` } : { code: 'REQUEST_FAILED', message: String(payload || `HTTP ${response.status}`) };
    throw new ApiError(response.status, error.code, error.message);
  }
  scheduleDiscussionBackfill(path, init.method);
  return payload as T;
}

function scheduleDiscussionBackfill(path: string, method?: string): void {
  if (method && method.toUpperCase() !== 'GET') return;
  const match = path.match(/^\/api\/groups\/([^/?]+)\/feed(?:\?|$)/);
  const groupId = match?.[1];
  if (!groupId || ensuredDiscussionGroups.has(groupId)) return;
  ensuredDiscussionGroups.add(groupId);
  void fetch(`/api/groups/${encodeURIComponent(groupId)}/discussions/ensure`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
    credentials: 'same-origin',
  }).then((result) => {
    if (!result.ok) ensuredDiscussionGroups.delete(groupId);
  }).catch(() => ensuredDiscussionGroups.delete(groupId));
}

export const postJson = <T>(path: string, body: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(body) });
